    <template>
      <div
        style="display:flex;flex-direction: column;"
      >
        <v-dialog
          v-model="loading"
          persistent
          width="300"
        >
          <v-card
            color="white"
          >
            <v-card-text>
              Loading Form Review
              <v-progress-linear
                indeterminate
                color="blue"
                class="mb-0"
              />
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="downloadingPdf"
          persistent
          width="300"
        >
          <v-card
            color="white"
          >
            <v-card-text>
              Generating PDF...
              <v-progress-linear
                indeterminate
                color="blue"
                class="mb-0"
              />
            </v-card-text>
          </v-card>
        </v-dialog>
        <UserFormLog
          v-if="showLogging"
          :userform="userform"
          @close="showLogging = false"
        />
        <v-dialog
          v-model="showSignatures"
          persistent
          width="900"
        >
          <UserFormSignatures
            v-if="showSignatures"
            :userform="userform"
            @close="showSignatures = false"
            @downloading="downloadingPdf = arguments[0]"
            @refetch="fetch()"
          />
        </v-dialog>
        <div
          class="userform-header"
        >
          <div
            class="userform-header-container"
          >
            <div>
              <div style="display:inline-block;">
                <div
                  style="font-size: 20px;font-weight: bold;"
                >
                  {{ userform.name }}
                </div>
                <div
                  v-if="userform.form_number || userform.party_name"
                  style="font-size: 14px;padding-top: 10px;"
                >
                  <span
                    style="font-style: italic;"
                  >
                    {{ userform.form_number }}
                  </span>
                  <span
                    style="padding-left: 10px;"
                  >
                    {{ userform.party_name }}
                  </span>
                </div>
              </div>
              <v-tooltip
                v-if="this.checkPermission('userform_answer_review', PERMISSIONS.CAN_EDIT)"
                left
              >
                <v-switch
                  v-model="answerReview"
                  style="float:right;margin-top:0;margin-right: 10px;"
                  prepend-icon="comment"
                  slot="activator"
                />
                <div>
                  <b>Answer Review</b><br />
                  Add comments and mark questions for follow-up.
                </div>
              </v-tooltip>
            </div>
            <div
              v-if="!loading"
            >
              <v-layout
                style="width:100%;"
              >
                <v-flex sm12 md4 style="padding-top: 15px;padding-right: 10px;">
                  <CasePreview
                    :xcase="userform.case"
                    :key="userform.case.id"
                  />
                </v-flex>
                <v-flex sm12 md8>
                  <v-select
                    v-model="userform.status"
                    :items="enabledStatuses"
                    item-text="name"
                    item-value="value"
                    item-disabled="apionly"
                    :disabled="!checkPermission('userform', PERMISSIONS.CAN_EDIT) || userform.locked"
                    label="Status"
                    flat
                    hide-details
                    @input="updateStatus"
                  >
                    <template slot="item" slot-scope="data">
                      <div>
                        <v-icon
                          left
                        >
                          {{data.item.icon}}
                        </v-icon>
                        {{data.item.name}}
                      </div>
                    </template>
                    <template slot="selection" slot-scope="data">
                      <v-icon
                        left
                      >
                        {{data.item.icon}}
                      </v-icon>
                      {{data.item.name}}
                      <v-btn
                        v-if="userform.status == 'esign'"
                        flat
                        small
                        color="primary"
                        style="position:absolute;right:20px;top:-5px;"
                        v-on:click.stop.prevent="resendEsign"
                        :disabled="reminderSending"
                      >
                        <v-icon left small>mdi-reminder</v-icon>
                        Re-Send E-signature Request
                      </v-btn>
                    </template>
                  </v-select>
                  <v-combobox
                    v-model.trim="userform.tags"
                    :items="tagResults"
                    :search-input.sync="tagSearch"
                    label="Tags"
                    multiple
                    item-text="tag"
                    item-value="tag"
                    :return-object="false"
                    flat
                    :disabled="!checkPermission('userform', PERMISSIONS.CAN_EDIT)"
                    small-chips
                    hide-selected
                    hide-details
                    auto-select-first
                    @input="updateTags"
                  >
                    <template v-slot:selection="{ attrs, item }">
                      <v-chip
                        v-bind="attrs"
                        label
                        small
                        :outline="item.includes(':')"
                      >
                        {{ item }}
                      </v-chip>
                    </template>
                  </v-combobox>
                </v-flex>
              </v-layout>
              <div
                style="display:flex;padding-top: 5px;"
              >
                <div
                  v-if="checkPermission('userform', PERMISSIONS.CAN_EDIT)"
                >
                  <v-btn
                    flat
                    small
                    color="secondary"
                    @click="ufSettings = true"
                  >
                    <v-icon left small>mdi-pencil</v-icon>
                    Edit Details
                  </v-btn>
                  <v-btn
                    flat
                    small
                    color="secondary"
                    @click="moveDialog = true"
                  >
                    <v-icon left small>mdi-briefcase-search</v-icon>
                    Transfer
                  </v-btn>
                </div>
                <div style="text-align:right;flex-grow: 1;">
                  <v-btn
                    flat
                    small
                    color="secondary"
                    @click="showSignatures = true"
                  >
                    <v-icon left small>mdi-file-sign</v-icon>
                    Signatures
                  </v-btn>
                  <v-btn
                    flat
                    small
                    color="secondary"
                    @click="showLogging = true"
                  >
                    <v-icon left small>history</v-icon>
                    Activity Log
                  </v-btn>
                  <v-menu
                    offset-y
                    left
                    open-on-hover
                    max-width="400"
                  >
                    <v-btn
                      flat
                      small
                      slot="activator"
                      color="primary"
                      @click="downloadPdf()"
                    >
                      <v-icon left small>description</v-icon>
                      Download
                    </v-btn>
                    <v-list
                      three-line
                    >
                      <v-list-tile
                        @click="downloadPdf()"
                      >
                        <v-list-tile-action>
                          <v-icon color="green">mdi-run-fast</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            Quick Download
                          </v-list-tile-title>
                          <v-list-tile-sub-title>
                            Download Recommended Version<br />
                            <small>Clicking "Download" above will Quick Download</small>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider />
                      <v-list-tile
                        @click="downloadPdf('internal')"
                      >
                        <v-list-tile-action>
                          <v-icon color="grey">description</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            Download Internal Copy
                          </v-list-tile-title>
                          <v-list-tile-sub-title>
                            Download with Headers & Blank Spaces
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile
                        @click="downloadPdf('submission')"
                      >
                        <v-list-tile-action>
                          <v-icon color="primary">description</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            Download Submission Copy
                          </v-list-tile-title>
                          <v-list-tile-sub-title>
                            Download with Template Submission Rules and Remove Document Headers
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile
                        v-if="userform.esigns.filter(esign => esign.status == 'Completed').length > 0"
                        @click="downloadPdf('esign')"
                      >
                        <v-list-tile-action>
                          <v-icon color="primary">mdi-signature-freehand</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            Download Signed Copy
                          </v-list-tile-title>
                          <v-list-tile-sub-title>
                            Downloads the current signed copy of the form.
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="page-container"
        >
          <UserFormNavigator
            :userform="userform"
            :details="affixedNav"
            id="userform-navigator"
            v-bind:class="{ 'userform-fixed-nav': affixedNav }"
          />
          <div id="userform-container">
            <v-expand-transition>
              <div
                v-if="isReadOnly && userform"
                v-bind:class="{ 'alert-bind': affixedNav }"
                style="padding-bottom:20px;"
              >
                <v-alert
                  v-if="userform.status == 'esign' || userform.status == 'client signing'"
                  :value="true"
                  type="info"
                  icon="mdi-signature-freehand"
                >
                  <span>
                    Signing in Progress
                  </span>
                </v-alert>
                <v-alert
                  v-else-if="userform.locked"
                  :value="true"
                  :outline="!affixedNav"
                  type="error"
                >
                  This form is currently <b>locked</b> by the claims administrator. To request a withdraw to make edits, please contact the claims administrator.
                </v-alert>
                <v-alert
                  v-else-if="checkPermission('userform', PERMISSIONS.CAN_EDIT)"
                  :value="true"
                  :outline="!affixedNav"
                  type="error"
                >
                  This form is currently <b>read-only</b> and the status must be changed in order to make edits.
                </v-alert>
              </div>
            </v-expand-transition>
            <div
              v-if="userform.status == 'esign declined'"
              v-bind:class="{ 'alert-bind': affixedNav }"
              style="padding-bottom:20px;"
            >
              <v-alert
                :value="true"
                :outline="!affixedNav"
                type="error"
              >
                <b>Signing Incomplete:</b> A signer declined to sign this form.<br /><br />
                <div
                  style="font-family: monospace;"
                >
                  {{lastEsign.message}}
                </div>
              </v-alert>
            </div>
            <v-form
              ref="formContainer"
            >
              <UserFormPartList
                v-if="!answersLoading"
                :user-form-id="userform.id"
                :parts="userform.sections"
              />
            </v-form>
            <v-card
              v-if="(!checkPermission('userform', PERMISSIONS.CAN_EDIT) && checkPermission('userform', PERMISSIONS.CAN_CONTACT_EDIT)) && !isReadOnly"
              flat
            >
              <v-card-actions>
                <v-spacer/>
                <v-btn
                  color="primary"
                  @click="showSubmitDialog"
                >
                  Submit for Review
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </div>
        <v-dialog
          v-model="esignDialog"
          persistent
          width="700"
        >
          <v-card
            v-if="esignDialog"
          >
            <v-toolbar
              dense
              flat
              dark
              color="blue"
            >
              <v-icon
                left
              >
                mdi-signature-freehand
              </v-icon>
              Requesting Electronic Signature
            </v-toolbar>
            <v-card-text v-if="userform.contact.email">
              <b>You are about to request an electronic signature from the client ({{userform.contact.full_name}}).</b><br />
              <br />
              <span>By requesting an electronic signature, this document will be locked and changes will not be permitted. If you change the status, the signature request or signed document will no longer be considered valid, and you will be required to request another signature from the client.<br /><br />
              </span>
            </v-card-text>
            <v-card-text v-else>
              <v-icon>
                mdi-email-alert
              </v-icon>
              <b>{{userform.contact.full_name}} does not have an e-mail assigned to the contact.</b><br />
              <br />
              <span>
                To request an electronic signature, please
                <router-link :to="{ name: 'Contact', params: { id: userform.contact.id } }">
                  <span>
                    Edit the Contact
                  </span>
                </router-link>
                to add an e-mail then try again.<br /><br />
              </span>
            </v-card-text>
            <v-expand-transition>
              <v-card-actions
                v-if="!statusUpdateLoading"
              >
                <v-spacer />
                <v-btn
                  @click="userform.status = previousStatus;esignDialog=false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  v-if="userform.contact.email"
                  @click="updateStatus()"
                  color="blue"
                  dark
                >
                  Request Signature
                </v-btn>
              </v-card-actions>
            </v-expand-transition>
            <v-expand-transition>
              <v-toolbar
                v-if="statusUpdateLoading"
                flat
                dense
              >
                <v-icon
                  left
                >
                  mdi-spin mdi-loading
                </v-icon>
                Sending Request to E-signature provider...
              </v-toolbar>
            </v-expand-transition>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="saveDialog"
          width="500"
          persistent
          transition="fade-transition"
        >
          <v-card
            color="white"
          >
            <div
              style="display: flex;flex-direction: column;justify-content: center;align-items: center;background: #004D40;color: white;padding: 20px;transition: background 1s ease;"
              :style="{'background': requiredComplete ? '#33691E' : '#E65100'}"
            >
              <v-icon
                color="white"
                size="72"
              >
                {{ requiredComplete ? 'assignment_turned_in' : 'assignment_late' }}
              </v-icon>
              <div
                style="font-size: 18px;font-weight: 700;padding-top: 10px;"
              >
                {{ requiredComplete ? 'Ready to Submit' : 'Not Ready to Submit' }}
              </div>
            </div>
            <v-card-text v-if="(pendingSaves == 0) && requiredComplete">
              <span>
                You are about to submit this form for review. Please ensure all information on this form is accurate and complete before submitting.<br /><br />
                If you need to make changes after submitting, contact <span class="legalFoot"/> to unlock the form.<br /><br />
                <v-alert
                  :value="!userform.hidden"
                  type="error"
                  outline
                >
                  You are submitting this form on behalf of {{ userform.contact.full_name }}, who will be unable to make changes after submission.
                </v-alert>
              </span>
            </v-card-text>
            <v-card-text
              v-else-if="!requiredComplete"
              style="text-align:center;"
            >
              <b>One or more questions require your attention before you can submit.</b>
              <br />
              There may be required, unanswered questions or incomplete answers preventing you from submitting this document.
              <br /><br />
              Questions that require your attention have been highlighted. Please select 'Go Back' and resolve these issues before submitting.
            </v-card-text>
            <v-card-text v-else>
              <span><b>You have an answer currently saving or that has failed to save.</b> Please check your answers or wait a moment before submittng, and try again.</span>
            </v-card-text>
            <v-progress-linear
              v-if="submitting"
              indeterminate
            />
            <v-card-actions>
              <v-spacer/>
              <v-btn
                flat
                color="grey"
                :disabled="submitting"
                @click="saveDialog = false"
              >
                go back
              </v-btn>
              <v-btn
                v-show="pendingSaves == 0 && requiredComplete"
                flat
                color="primary"
                :disabled="submitting"
                @click="submitForm()"
              >
                I Understand, Submit
              </v-btn>
              <v-spacer/>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="moveDialog"
          persistent
          width="700"
        >
          <v-card>
            <v-toolbar
              dense
              flat
              dark
            >
              <v-icon
                left
              >
                mdi-briefcase-search
              </v-icon>
              Move Form
              <v-spacer />
              <v-btn
                fab 
                flat
                @click="moveDialog = false" 
              >
                x
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <p>
                <b>Move form from one case to another.</b> This search page only shows 10 matching cases.
              </p>
              <div>
                <v-text-field
                  v-model="caseSearch"
                  label="Search for Case"
                />
                <v-btn
                  @click="fetchCase()"
                >
                  Search
                </v-btn>
              </div>
              <div>
                <v-data-table
                  :items="cases"
                  disable-initial-sort
                  :headers="headers"
                  :loading="caseSearching"
                  dense
                >
                  <template slot="no-data">
                    <tr>
                      <td colspan="3">
                        <div style="text-align:center;padding:25px;">
                          <v-icon size="125px">find_in_page</v-icon>
                          <h3>No Results</h3>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <template
                    slot="items"
                    slot-scope="props"
                  >
                    <tr>
                      <td>
                        <CasePreview
                          :xcase="props.item"
                          :inset="true"
                          :key="props.item.id"
                        />
                      </td>
                      <td>
                        <ContactPreview
                          :contact="props.item.contact"
                          :inset="true"
                          :key="props.item.contact.id"
                        />
                      </td>
                      <td class="justify-center layout px-0">
                        <v-btn
                          small
                          @click="move(props.item.id)"
                        >
                          Move
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
        
        <v-dialog
          v-model="statusChangeWarning"
          persistent
          width="500"
        >
          <v-card
            style="color: white; background: #FF6F00;text-align:center;"
          >
            <v-card-text>
              <h2>This form is signed and locked</h2>
              <p>
                The status you are attempting to change the form to will unlock the form.
              </p>
              <div
                style="padding: 10px;margin:5px;border: 1px solid #EF6C00;background: #FAFAFA;border-radius: 3px;text-align:left;color:black;"
              >
                <ul>
                  <li>
                    <b>The current signature will be voided</b><br />
                    If the current signature is a E-signature pending completion, it will be cancelled.
                  </li>
                  <li>
                    <b>The contact and any additional signers may need to re-sign</b><br />
                    The contact and any additional signatories must re-sign the document if any answer is changed. Electronic signatures are cryptographically signed, and a previously signed document cannot be edited or modified.
                  </li>
                </ul>
              </div>
            </v-card-text>
            <v-expand-transition>
              <v-card-actions
                v-if="!statusUpdateLoading"
                style="background: #FAFAFA;"
              >
                <v-btn
                  @click="updateStatus()"
                  color="#BF360C"
                  flat
                >
                  Change Status
                </v-btn>
                <v-spacer />
                <v-btn
                  @click="userform.status = previousStatus;statusChangeWarning=false"
                  color="primary"
                >
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-expand-transition>
            <v-expand-transition>
              <v-toolbar
                v-if="statusUpdateLoading"
                flat
                dense
              >
                <v-icon
                  left
                >
                  mdi-spin mdi-loading
                </v-icon>
                Changing Status and Marking Documents...
              </v-toolbar>
            </v-expand-transition>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="pendingEsignWarning"
          persistent
          width="500"
        >
          <v-card
            style="color: white; background: #D84315;text-align:center;"
          >
            <v-card-text>
              <h2>Signing in progress</h2>
              <p>
                Changing the status will cancel the outgoing electronic signature request
              </p>
              <div
                style="padding: 10px;margin:5px;border: 1px solid #EF6C00;background: #FAFAFA;border-radius: 3px;text-align:left;color:black;"
              >
                This form is currently pending an electronic signature. Changing the status will cancel the outgoing request and void any signatures that have been captured.<br /><br />
                <b>Need to resend the request?</b><br />
                Select "Re-send E-signature Request" to remind the contact or any additional signers to sign the form.
              </div>
            </v-card-text>
            <v-expand-transition>
              <v-card-actions
                v-if="!statusUpdateLoading"
                style="background: #FAFAFA;"
              >
                <v-btn
                  @click="updateStatus()"
                  color="#BF360C"
                  flat
                >
                  Change Status
                </v-btn>
                <v-spacer />
                <v-btn
                  @click="userform.status = previousStatus;pendingEsignWarning=false"
                  color="primary"
                >
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-expand-transition>
            <v-expand-transition>
              <v-toolbar
                v-if="statusUpdateLoading"
                flat
                dense
              >
                <v-icon
                  left
                >
                  mdi-spin mdi-loading
                </v-icon>
                Changing Status and Marking Documents...
              </v-toolbar>
            </v-expand-transition>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="ufSettings"
          width="500"
          persistent
        >
          <v-card>
            <UserFormSettings
              :key="userform.id"
              :userform="userform"
              @cancel="ufSettings = false"
              @save="ufSettings = false;fetch()"
            />
          </v-card>
        </v-dialog>
        
        <v-snackbar
          v-model="reminderSent"
          right top
          :timeout="6000"
        >
          <v-icon color="white">mdi-reminder</v-icon>
          Reminder Sent to Latest Signer
        </v-snackbar>
      </div>
    </template>

    <script>
    import { mapMutations, mapGetters, mapState } from 'vuex'
    import api from '@/api'
    import UserFormNavigator from './UserFormNavigator'
    import UserFormLog from './UserFormLog'
    import UserFormSignatures from './UserFormSignatures'
    import UserFormPartList from './UserFormPartList'
    import UserFormSettings from './UserFormSettings'
    import CasePreview from '@/components/admin/cases/CasePreview'
    import ContactPreview from '@/components/admin/contacts/ContactPreview'
    import GlobalConstants from '@/globals'

    export default {
      name: 'UserForm',
      components: {
        UserFormNavigator,
        UserFormPartList,
        UserFormLog,
        UserFormSignatures,
        ContactPreview,
        CasePreview,
        UserFormSettings
      },
      data () {
        return {
          userform: {},
          loading: true,
          answersLoading: false,
          statusUpdateLoading: false,
          statusChangeWarning: false,
          pendingEsignWarning: false,
          downloadingPdf: false,
          showLogging: false,
          showSignatures: false,
          tagSearch: null,
          tagResults: [],
          statusStrings: null,
          enabledStatuses: [],
          affixedNav: false,
          esignDialog: false,
          previousStatus: null,
          readOnlyStatuses: ['client signing', 'submitted', 'resubmitted', 'withdrawn', 'complete', 'esign', 'esign returned', 'not completing', 'claimsadmin review', 'sm review', 'accepted - qp', 'accepted - tier'],
          reminderSent: false,
          reminderSending: false,
          answerReview: true,
          moveDialog: false,
          caseSearching: false,
          caseSearch: null,
          ufSettings: false,
          saveDialog: false,
          requiredComplete: false,
          cases: [],
          submitting: false,
          headers: [
            { text: 'Case', value: 'case', sortable: false },
            { text: 'Contact', value: 'contact', sortable: false },
            {
              text: 'Actions', align: 'center', sortable: false
            }
          ],
        }
      },
      created () {
        if (this.$route.params.id) {
          this.fetch()
        }
        window.addEventListener('scroll', this.handleScroll)
        this.answerReview = this.reviewEnabled
        this.checkForOutage()
      },
      computed: {
        ...mapGetters('userform', [
          'pendingSaves',
          'isReadOnly',
          'reviewEnabled'
        ]),
        ...mapGetters('auth', [
            'getDomainInfo',
          ]
        ),
        ...mapState('userform', [
          'handleBypass'
        ]),
        status () {
          if (this.userform) {
            return this.userform.status
          }
        },
        lastEsign () {
          if (this.userform) {
            return this.userform.esigns.slice(-1)
          }
        }
      },
      watch: {
        pendingSaves () {
          if (this.pendingSaves > 0) {
            window.onbeforeunload = function () {
              return true
            }
          } else {
            window.onbeforeunload = null
          }
        },
        tagSearch () {
          if (this.tagSearch) {
            this.fetchTags()
          }
        },
        status () {
          this.setReadOnly(this.readOnlyStatuses.includes(this.status))
        },
        answerReview () {
          this.setReviewEnabled(this.answerReview)
        },
        getDomainInfo: {
          handler(){
            this.statusStrings = this.checkForOutage()
          },
          immediate:true
        }
      },
      methods: {
        ...mapMutations('userform', [
          'setAnswerDatabase',
          'setReadOnly',
          'setSectionStructure',
          'setReviewEnabled',
          'setNestedTemplate'
        ]),
        submitForm () {
          this.submitting = true
          localStorage.removeItem('lastQuestion:' + this.userform.id)
          api.userform.userForm.submit(this.userform.id)
            .then(response => {
              if (response.message) {
                alert(response.message)
              }
              this.submitting = false
              this.saveDialog = false
              this.fetch()
            })
        },
        fetchCase () {
          this.contactSearching = true
          api.cases.cases.list({
            search: this.caseSearch
          })
            .then(data => {
              this.cases = data.results
              this.caseSearching = false
            })
        },
        showSubmitDialog () {
          this.requiredComplete = this.$refs.formContainer.validate()
          this.saveDialog = true
        },
        fetch () {
          this.loading = true
          this.answersLoading = true
          api.userform.userForm.get(this.$route.params.id)
          .then(userForm => {
            this.documentTitle((userForm.party_name || userForm.contact.full_name) + ' - ' + (userForm.form_number || userForm.contact.cuid) + ' < ' + userForm.name)
            this.userform = userForm
            this.setNestedTemplate(this.userform)
            this.userform.tags = this.resortTags(this.userform.tags)
            this.setSectionStructure(userForm.sections)
            this.loading = false
            api.userform.userForm.getAnswerDb(this.$route.params.id)
            .then(answerDb => {
              this.setAnswerDatabase(answerDb)
              this.previousStatus = userForm.status
              var lastViewedObject = JSON.parse(localStorage.getItem('user-last-viewed:' + this.$store.state.auth.id)) || []
              var thisFormObject = {
                type:'form',
                id: this.userform.id,
                name: this.userform.name,
                party_name: this.userform.party_name,
                form_number: this.userform.form_number,
                tags: this.userform.tags
              }
              if (lastViewedObject !== []) {
                if (lastViewedObject.some(e => e.id === this.userform.id)) {
                  lastViewedObject = lastViewedObject.filter(obj => {
                    return obj.id !== this.userform.id
                  })
                }
                lastViewedObject.unshift(thisFormObject)
                while (lastViewedObject.length > 10) {
                  lastViewedObject.pop()
                }
              } else {
                lastViewedObject.push(thisFormObject)
              }
              localStorage.setItem('user-last-viewed:' + this.$store.state.auth.id, JSON.stringify(lastViewedObject))
              this.enabledStatuses = JSON.parse(JSON.stringify(this.statusStrings))
              if (this.userform.valid_esign) {
                this.enabledStatuses.filter(status => {
                  if (status.value == "esign" && this.userform.valid_esign) {
                    status.apionly = true
                  }
                  return status
                })
              }
              this.answersLoading = false
            })
          })
          .finally(() => {
            if (!this.checkPermission('userform', this.PERMISSIONS.CAN_EDIT)) {
              if (this.checkPermission('userform', this.PERMISSIONS.CAN_CONTACT_EDIT)) {  
                if (!['new', 'client started'].includes(this.userform.status))
                  this.setReadOnly(true)
              }
              else
                this.setReadOnly(true)                
            }
          })
        },
        resendEsign () {
          this.reminderSending = true
          api.userform.userForm.resendEsign(this.userform.id)
            .then(() => {
              this.reminderSent = true
            })
            .finally(() => {
              this.reminderSending = false
            })
        },
        move (contactId) {
          api.userform.userForm.move(this.userform.id, contactId)
            .then(() => {
              this.moveDialog = false
              this.fetch()
            })
        },
        fetchTags () {
          api.userform.userformTags.get(this.tagSearch)
            .then(tagResults => {
              this.tagResults = tagResults
            })
        },
        updateStatus () {
          const newStatus = this.userform.status.toLowerCase()
          if (newStatus === "esign" && !this.esignDialog) {
            this.esignDialog = true
          } else {
            //
            //  This IF statement checks if:
            //    Are there any esign Documents?
            //    Is a confirmation dialog open?
            //    Is the previous status read only?
            //    Is the next status *not* read only?
            //
            if (this.userform.valid_esign &&
              (!this.statusChangeWarning && !this.esignDialog) &&
              (this.readOnlyStatuses.includes(this.previousStatus)) &&
              (!this.readOnlyStatuses.includes(newStatus))) {
              this.statusChangeWarning = true
            //
            //  This IF statement checks if:
            //    Is the status pending signature?
            //    Is a confirmation dialog open?
            //
            } else if (
              ["esign", "client signing"].includes(this.previousStatus) &&
              !this.pendingEsignWarning
            ) {
              this.pendingEsignWarning = true
            } else {
              this.statusUpdateLoading = true
              const userFormUpdate = {
                id: this.userform.id,
                status: newStatus
              }
              api.userform.userForm.save(userFormUpdate)
                .then(userForm => {
                  this.statusUpdateLoading = false
                  this.pendingEsignWarning = false
                  this.esignDialog = false
                  this.statusChangeWarning = false
                  this.userform = userForm
                  this.enabledStatuses = JSON.parse(JSON.stringify(this.statusStrings))
                  if (this.userform.valid_esign) {
                    this.enabledStatuses.filter(status => {
                      if (status.value == "esign" && this.userform.valid_esign) {
                        status.apionly = true
                      }
                      return status
                    })
                  }
                  this.previousStatus = userForm.status
                  this.$forceUpdate()
                })
            }
          }
        },
        updateTags (event) {
          this.tagSearch = ''
          var tagsCleaned = []
          this.userform.tags.forEach((t) => {
            tagsCleaned.push(t.trim())
          })
          const userFormUpdate = {
            id: this.userform.id,
            tags: tagsCleaned
          }
          api.userform.userForm.save(userFormUpdate)
            .then(userForm => {
              this.userForm = userForm
            })
        },
        downloadPdf (sub = null) {
          this.downloadingPdf = true
          api.userform.userForm.downloadPdf(this.$route.params.id, sub)
          .then(response => {
            this.downloadingPdf = false
            let blob = new Blob([response.data])
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = (this.userform.form_number || this.userform.contact.cuid) + '_' + this.userform.name + '.pdf'
            link.click()
          })
        },
        handleScroll (event) {
          if (event.target.scrollingElement.scrollTop > 200) {
            this.affixedNav = true
          } else {
            this.affixedNav = false
          }
        },
        checkForOutage(){
          if('outage' in this.getDomainInfo && this.getDomainInfo.outage.includes("sign")){
            return this.getStatuses().filter( status => {
              return status.name != "Request E-Signature"
            })  
          } else {
            return this.getStatuses()
          }
        }
      },
      beforeRouteLeave (to, from, next) {
        if (this.pendingSaves > 0 && !this.handleBypass) {
          const alertDialog = window.confirm('Are you sure you want to leave? You have unsaved changed!')
          if (alertDialog) {
            next()
          } else {
            next(false)
          }
        } else {
          next()
        }
      },
      destroyed () {
        window.removeEventListener('scroll', this.handleScroll)
      }
    }
    </script>

    <style>
    #userform-navigator {
      float:left;
      width: 250px;
      height: 100%;
      overflow-y: auto;
    }

    .userform-fixed-nav {
      position: fixed;
      top: 100px;
    }

    .userform-header {
      width:100%;
      background: #ECEFF1;
      border-bottom: 1px solid #78909C;
    }

    #userform-container {
      width: calc(100% - 250px);
      margin-left: 250px;
    }

    .spin {
        -webkit-animation: spin 1000ms infinite linear;
        animation: spin 1000ms infinite linear;
    }
    @-webkit-keyframes spin {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
        }
    }
    @keyframes spin {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
        }
    }

    .v-list__tile__title, .v-select__selections {
      text-transform: capitalize;
    }

    .userform-header-container {
      position: relative;
      width: 100%;
      margin:auto;
      margin-top:10px;
      height: calc(100% - 25px);
      padding: 10px 10px 0 10px;
      max-width: 1600px;
    }

    .page-container {
      max-width: 1600px;
      margin:auto;
      position:relative;
      width:100%;
      padding: 15px;
    }

    .alert-bind {
      position: fixed;
      z-index:2;
      top:44px;
      left:0;
      right:0;
    }

    .v-list--disabled {
      display: none;
    }
    </style>
